import React, { ReactNode } from 'react';
import { Document, Font, Page, StyleSheet, View } from '@react-pdf/renderer';

import { OrientationOptions } from 'screens/Applications&WorkOrders/Hooks/useOperationPdf';
import LightItalic from '../../fonts/Noto_Sans/NotoSans-LightItalic.ttf';
import RegularFont from '../../fonts/Noto_Sans/NotoSans-Regular.ttf';
import MediumFont from '../../fonts/Noto_Sans/NotoSans-Medium.ttf';
import SemiBoldFont from '../../fonts/Noto_Sans/NotoSans-SemiBold.ttf';
import Footer from '../Footer';
import { en, Locale } from '../../locales';

const PAGE_PADDING = 36;
const FOOTER_HEIGHT = 84;

Font.register({
  family: 'Noto Sans',
  fonts: [
    { src: LightItalic, fontStyle: 'italic', fontWeight: 'light' },
    { src: RegularFont },
    { src: MediumFont },
    { src: SemiBoldFont }
  ]
});

// Disable hyphenation
Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create({
  body: {
    padding: PAGE_PADDING,
    paddingBottom: FOOTER_HEIGHT
  },
  pageContent: {
    maxHeight: '100%'
  }
});

interface LayoutProps {
  children: ReactNode;
  generatedFullDate: Record<string, string>;
  exportLanguage?: string;
  orientation?: OrientationOptions;
  locale?: Locale;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  generatedFullDate,
  exportLanguage = 'english',
  orientation = 'portrait',
  locale = en
}) => {
  return (
    // @ts-ignore - library issue
    <Document>
      {/* @ts-ignore - library issue */}
      <Page style={styles.body} orientation={orientation}>
        <View style={styles.pageContent}>{children}</View>
        <Footer
          copyrightText={locale.common.copyright}
          generatedOnText={locale.common.generated_on}
          exportLanguage={exportLanguage}
          fullDate={generatedFullDate}
          getPageNumberText={locale.common.getPageNumberText}
        />
      </Page>
    </Document>
  );
};

export default Layout;
